import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isUserAuthenticated, redirectToCognitoLogin } from '../utils/cognitoAuth';

function HomeRedirect() {
  const isAuthenticated = isUserAuthenticated();

  useEffect(() => {
    if (!isAuthenticated) {
      redirectToCognitoLogin();
    }
  }, [isAuthenticated]);

  return isAuthenticated ? <Navigate to="/planning" replace /> : null;
}

export default HomeRedirect;
